  

// Vision UI Dashboard React base styles
import colors from "assets/theme/base/colors";

const { dark } = colors;

export default {
  styleOverrides: {
    root: {
      color: "#fff",

      "&.Mui-focused": {
        color: "#fff"
      }
    },
  },
};
